import React from 'react'
import { useOrganizationSettingsQuery } from '../organization-settings/use-organization-settings'

export interface ChildProps {
  readonly loading: boolean
  readonly diagnosticsCollectionEnabled: boolean
  readonly restrictedEditRoleEnabled: boolean
  readonly isEOP: boolean
  aimlServiceEnabled: boolean
}

interface Props {
  readonly organizationUuid: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export const DIAGNOSTICS_ORGANIZATION_SETTINGS_LOADER_TEST_ID =
  'diagnostics-organization-settings-loader-test-id'

export const DiagnosticsOrganizationSettingsLoader = ({
  organizationUuid,
  children
}: Props) => {
  const { data, isError, isLoading } = useOrganizationSettingsQuery({
    organizationUuid
  })

  if (isError) {
    return null
  }

  return (
    <div data-testid={DIAGNOSTICS_ORGANIZATION_SETTINGS_LOADER_TEST_ID}>
      {children({
        loading: isLoading,
        diagnosticsCollectionEnabled:
          !!data && !!data.diagnosticsCollectionEnabled,
        restrictedEditRoleEnabled: !!data && !!data.restrictedEditRoleEnabled,
        isEOP: !!data && !!data.isEOP,
        aimlServiceEnabled: !!data && !!data.aimlServiceEnabled
      })}
    </div>
  )
}
